import type { FunctionComponent } from 'react';

import { IconAsterisk } from '~/ui/core/icons';

export const DraftedToMatch: FunctionComponent = () => (
    <span className="inline-flex items-center gap-xs text-xxs leading-snug text-black-500">
        <IconAsterisk size={10} className="text-orange-800" />
        Drafted to match
    </span>
);
